import makeStyles from '@mui/styles/makeStyles'

const useAddNewPlantStyles = makeStyles({
  root: {
    select: {
      borderRadius: '50px',
      backgroundColor: '#ffffff',
      '&:focus': {
        borderRadius: '50px',
        backgroundColor: '#ffffff',
      },
      '& .MuiSelect-icon': {
        color: '#000000',
      },
      '&:hover': {
        backgroundColor: '#ffffff',
      },
    },
    menuItemSelected: {
      backgroundColor: '#fff',
      '&:hover': {
        backgroundColor: '#fff',
      },
    },
    '&.MuiAccordionDetails-root': {
      borderBottom: 'none',
    },
    '&.MuiAccordionSummary-root': {
      borderBottom: 'none',
    },
    '& .MuiInputBase-root': {
      color: '#000',
      backgroundColor: 'white',
      borderRadius: '50px',
      border: 'none',
      boxShadow: '4px 4px 15px rgba(0, 0, 0, 0.05)',
    },
    '& .MuiIconButton-root': {
      color: '#000',
    },
    '& .MuiPickersDay-daySelected': {
      backgroundColor: 'white',
      border: 'none',
      '&:hover': {
        backgroundColor: 'white',
      },
    },
    '& .MuiFilledInput-input': {
      backgroundColor: '#fff',
      borderRadius: '50px',
      border: 'none',
      boxShadow: '4px 4px 15px rgba(0, 0, 0, 0.05)',
      '&:hover': {
        border: 'none',
        borderBottom: 'none',
        backgroundColor: 'white',
      },
    },
    '& .MuiFilledInput-root.Mui-focused': {
      backgroundColor: '#fff',
    },
    '&:hover:not(.Mui-disabled, .Mui-error):before': {
      borderBottom: 'none',
    },
    '& .MuiFilledInput-underline:before': {
      borderBottom: 'none',
      '&:hover': {
        borderBottom: 'none',
      },
    },
    '& MuiInputBase-root-MuiFilledInput-root': {
      '&:hover': {
        backgroundColor: 'white',
        '&:before': {
          borderBottom: 'none',
        },
      },
    },

    '& MuiInputBase-root-MuiFilledInput-root:hover:not(.Mui-disabled, .Mui-error):before':
      {
        borderBottom: 'none',
      },
    '& .MuiFilledInput-underline:after': {
      borderBottom: 'none',
    },

    '& MuiPaper-root-MuiAccordion-root': {
      boxShadow: 'none !important',
    },
    '&:hover': {
      border: 'none !important',
      borderBottom: 'none',
    },
    '& MuiButtonBase-root-MuiTab-root': {
      border: '1px solid #5968B7',
      boxShadow: '4px 4px 15px rgba(0, 0, 0, 0.05)',
      borderRadius: '6px',
      padding: '10px 30px',
      margin: '0px 10px',
    },
    '& MuiPaper-root-MuiAccordion-root:before': {
      backgroundColor: 'transparent',
    },
  },
})

export default useAddNewPlantStyles
